// web/src/pages/Home.tsx
import { Shell } from "../components/layout/Shell";
import { call, type Me } from "../lib/api";

export function Home({ me, onLeave }: { me: Me; onLeave: () => void }) {
  async function leave() {
    await call("/api/logout", {});
    onLeave();
  }

  return (
    <Shell me={me} onLeave={leave} active="home">
      <div className="p-6 text-[13px] text-fg-faint" data-annot="экран Главная">
        Раздел «Сток» — в меню слева: что лежит в коробах, чего нет на Ozon и
        сколько мы отдаём на FBS.
      </div>
    </Shell>
  );
}
